// src/pages/Dashboard.jsx
import React, { useEffect, useState } from "react";
import OverviewClassic from "./OverviewClassic";
import OverviewFTE from "./OverviewFTE";
import OverviewReadOnly from "./OverviewReadOnly";

export default function Dashboard() {
    // ✅ Hooks first (never conditional)
    const [role, setRole] = useState(null);           // null = not loaded yet
    const [isFteFlag, setIsFteFlag] = useState(null); // null = not loaded yet

    // Route guard as a plain boolean, not an early return before hooks
    const isUnauthorizedPath =
        typeof window !== "undefined" && window.location.pathname === "/unauthorized";

    useEffect(() => {
        if (isUnauthorizedPath) return;

        const sync = () => {
            const rawRole = (sessionStorage.getItem("tb_role") || "").trim();
            const selectedRole = (sessionStorage.getItem("tb_role_user_selected") || "").trim();
            const fte = sessionStorage.getItem("tb_isFte");
            const isFte = fte === "1";

            // During multi-role switch, tb_role can be briefly empty while
            // tb_role_user_selected already contains the user choice.
            const effectiveRole = rawRole || selectedRole || "";

            setRole((prev) => (prev !== effectiveRole ? effectiveRole : prev));
            setIsFteFlag((prev) => (prev !== isFte ? isFte : prev));
        };

        // Read immediately on mount (covers the key={roleKey} remount path)
        sync();

        // Keep polling so any subsequent same-tab role change is also picked up,
        // even if App.js key remount doesn't fire (e.g. already on /dashboard).
        const id = setInterval(sync, 250);

        // Cross-tab support
        const onStorage = (e) => {
            if (e.storageArea === sessionStorage &&
                (e.key === "tb_role" || e.key === "tb_isFte" || e.key === "tb_role_user_selected")) {
                sync();
            }
        };
        window.addEventListener("storage", onStorage);

        return () => {
            clearInterval(id);
            window.removeEventListener("storage", onStorage);
        };
    }, [isUnauthorizedPath]);

    // If this page ever renders on /unauthorized, render nothing
    if (isUnauthorizedPath) return null;

    // Still loading role/FTE info (null = not yet read from sessionStorage)
    if (role === null && isFteFlag === null) {
        return (
            <div className="main">
                <div className="card">Loading your dashboard...</div>
            </div>
        );
    }

    // If still unresolved, keep a stable loading shell instead of forcing
    // session clear/reload during transient auth/bootstrap windows.
    if (!role && !isFteFlag) {
        return (
            <div className="main">
                <div className="card">Loading your dashboard...</div>
            </div>
        );
    }

    const roleLc = (role || "").toLowerCase().trim();
    const loginName =
        (sessionStorage.getItem("tb_name") || "").trim() ||
        (sessionStorage.getItem("tb_email") || "").trim() ||
        "User";

    if (roleLc === "read only") {
        return <OverviewReadOnly />;
    }

    const showFTE = roleLc === "fte nominator";
    return showFTE ? <OverviewFTE /> : <OverviewClassic />;
}
